import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { SelectOption } from "shared/types/Select"
import { RoomType } from "shared/types/references/RoomType"

import { ParseKeys } from "i18next"

export function useRoomTypeOptions(): SelectOption<RoomType>[] {
  const { t } = useTranslation()

  return useMemo(
    () =>
      Object.values(RoomType)
        .map(roomType => ({
          label: t(`RoomType.${roomType}` as ParseKeys) as string,
          value: roomType
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [t]
  )
}
